/* Polsk katalog for locale-manual-preview-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'manualPreview.reset': 'Resetuj',
  'manualPreview.title': 'Księgowanie',
  'manualPreview.details': 'Szczegóły',
  'manualPreview.summary': 'Podsumowanie według kont',
  'manualPreview.date': 'Data',
  'manualPreview.account': 'Konto',
  'manualPreview.vat': 'Kod VAT',
  'manualPreview.before': 'Saldo przed',
  'manualPreview.amount': 'Kwota',
  'manualPreview.after': 'Saldo po',
  'manualPreview.debit': 'Wn',
  'manualPreview.credit': 'Ma',
  'manualPreview.net': 'Zmiana netto',
  'manualPreview.warning.balances': 'Salda nie są dostępne w danych księgowych. Zapisy są pokazywane bez salda przed i po.',
  'manualPreview.warning.editing': 'Przy korekcie pokazywany jest tutaj zapis zastępczy. Saldo przed i po nie jest pokazywane, ponieważ korekta może także stornować wcześniejszy dowód księgowy.',
  'manualPreview.warning.years': 'Zapisy obejmują kilka lat kalendarzowych. Linie księgowań są pokazywane, ale saldo przed i po nie jest obliczane w przekroju lat.',
  'manualPreview.warning.country': 'W podglądzie brakuje kraju rachunkowości lub podgląd nie obsługuje wybranego ujęcia VAT dla tego kraju.',
});
